<div class="modal-header">
  <h4 id="override-acquisition-form-modal" class="modal-title">
    {{ "Import acquisition sessions from CSV" | translate }}
  </h4>

  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
  </form>
</div>

<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="(loadingService.loading$ | async) || form.pending"
    [disabled]="form.pending"
    (click)="onImportClicked()"
    class="btn btn-primary"
    type="button"
  >
    {{ "Import" | translate }}
  </button>
</div>
